export const CALCULATOR_FEATURE_NAME = 'fulldeal-calculator-editable';
